import React from 'react';
import PropTypes from 'prop-types';

import Icon from './Icon';


const SuccessIcon = ({id, className}) => (
    <Icon id={id} type={'success'} className={className}>
        <span className="checkmark" />
    </Icon>
);

SuccessIcon.propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
};

SuccessIcon.defaultProps = {
    id: null,
    className: '',
};

export default SuccessIcon;



// WEBPACK FOOTER //
// ./src/components/SuccessIcon.js